import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import {
  AFFILIATIONS_FILTER_ID,
  AUTHORS_OF_SCI_DOC_FILTER_ID,
  INVENTORS_OF_PATENTS_FILTER_ID,
  shipmentTimeFilterId,
  shippingTimeFilterId,
} from '@Containers/ResultsFilters/ResultsFiltersConstants';
import UserDatabases from '@Services/UserDatabases';

const filtersFilter = (item, params) => {
  const { value } = item;

  // Exclude new author name search filters if feature is not enabled
  if (
    !Auth.isFeatureEnabled(FEATURES.enableAuthorNameSearchImprovements) &&
    [AUTHORS_OF_SCI_DOC_FILTER_ID, AFFILIATIONS_FILTER_ID, INVENTORS_OF_PATENTS_FILTER_ID].includes(value)
  ) {
    return false;
  }

  switch (value) {
    case 'CIT.IS': {
      return !Auth.isFeatureEnabled(FEATURES.disableRccContentFrom);
    }
    case shipmentTimeFilterId: {
      return false;
    }
    case shippingTimeFilterId: {
      return true;
    }
    case 'YY': {
      const { databaseId } = params;
      return !(UserDatabases.isRCSDatabase(databaseId) && Auth.isFeatureEnabled(FEATURES.hideRCSStructureFilter));
    }
    case 'PROD.SDS': {
      const { databaseId } = params;
      return !(UserDatabases.isRCSDatabase(databaseId) && Auth.isFeatureEnabled(FEATURES.hideRCSSDSFilter));
    }
    default: {
      return true;
    }
  }
};

const filtersMapper = (item) => {
  const { value } = item;
  switch (value) {
    case 'CIT.AU': {
      return !Auth.isFeatureEnabled(FEATURES.disablePatentSightUIChanges)
        ? item
        : {
            ...item,
            title: 'Authors',
          };
    }
    case 'CIT.PA': {
      return !Auth.isFeatureEnabled(FEATURES.disablePatentSightUIChanges)
        ? item
        : {
            ...item,
            title: 'Patent Assignee',
          };
    }
    default: {
      return item;
    }
  }
};

export default (response, params) => response.filter((item) => filtersFilter(item, params)).map(filtersMapper);
